<script lang="ts">
  import MainMenuItem from "./MainMenuItem.svelte";
</script>

<div class="main-menu noselect">
  <aside class="menu">
    <ul class="menu-list">
      <MainMenuItem link="/" label="Indietro" icon="keyboard_double_arrow_left" />
    </ul>

    <p class="menu-label">Procedure Qualità</p>
    <ul class="menu-list">
      <MainMenuItem link="/quality-procs" label="Procedure" icon="workspace_premium" />

      <!-- procs -->
      <MainMenuItem link="/quality-sanification" label="Sanificazione" icon="next_plan" />
      <MainMenuItem link="/quality-infest" label="Infestanti" icon="next_plan" />
      <MainMenuItem link="/quality-h2o" label="H2O" icon="next_plan" />
      <MainMenuItem link="/quality-external-maintenance" label="Manutenzioni Esterne" icon="next_plan" />
      <MainMenuItem link="/quality-internal-maintenance" label="Manutenzioni Interne" icon="next_plan" />
      <MainMenuItem link="/quality-calibration" label="Tarature" icon="next_plan" />
      <MainMenuItem link="/quality-welfare" label="Benessere" icon="next_plan" />
      <MainMenuItem link="/quality-waste" label="Smaltimento" icon="next_plan" />
      <MainMenuItem link="/quality-training" label="Formazione" icon="next_plan" />
      <MainMenuItem link="/quality-atp" label="ATP" icon="next_plan" />
      <MainMenuItem link="/quality-analysis" label="Analisi" icon="next_plan" />
      <MainMenuItem link="/quality-schedule-analysis" label="Scadenziario Analisi" icon="next_plan" />
      <MainMenuItem link="/quality-schedule-maintenance" label="Scadenziario Manut." icon="next_plan" />
      <MainMenuItem link="/quality-incident" label="Non conformità" icon="next_plan" />
    </ul>
  </aside>
</div>

<style>
  .main-menu .menu-label:not(:last-child) {
    margin-bottom: 0.25em;
  }
</style>
